import React from "react";
import Proptypes from "prop-types";
import styles from "./addbrand.module.scss";
import { Button } from "reactstrap";
import LumiRXLogo from "../../../../assets/images/logo/single-logo.png";
import { toast } from "react-toastify";

const ReviewModal = ({
  setStep,
  toggle,
  handleSubmit,
  formikSubmitting,
  noErrors,
}) => {
  return (
    <>
      <div className={styles["logo_container"]}>
        <img src={LumiRXLogo} width={335} height={94} alt="logo" />
      </div>
      <div className={styles["review_text_container"]}>
        <p className={styles["review_text"]}>
          Lumi will review the information you&apos;ve submitted to verify its
          authenticity. This process could take a few days, so make sure
          you&apos;ve added everything you need to support your application.
        </p>
      </div>

      <div className={styles["submit_btns"]}>
        <div className={styles["button_div"]}>
          <Button
            className={styles["button_style_cancel"]}
            onClick={() => {
              setStep(2);
            }}
          >
            Back
          </Button>
        </div>
        <div className={styles["button_div"]}>
          <Button
            className={styles["button_style_add"]}
            onClick={() => {
              if (noErrors) {
                toggle();
                handleSubmit();
              } else toast.error("Please resolve errors before submitting");
            }}
            disabled={formikSubmitting}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
};
ReviewModal.propTypes = {
  setStep: Proptypes.func,
  toggle: Proptypes.func,
  handleSubmit: Proptypes.func,
  formikSubmitting: Proptypes.bool,
  noErrors: Proptypes.bool,
};
export default ReviewModal;
